// extracted by mini-css-extract-plugin
export default {"actionTitle":"ModalActions_actionTitle__YNwn0"};